// extracted by mini-css-extract-plugin
module.exports = {"tooltip-trigger":"Tooltip_tooltip-trigger__2tuM5","tooltip-body-wrapper":"Tooltip_tooltip-body-wrapper__1k258","tooltip-body":"Tooltip_tooltip-body__3ckdJ"};